<template><div><h1 id="offene-bestellungen" tabindex="-1"><a class="header-anchor" href="#offene-bestellungen"><span>Offene Bestellungen</span></a></h1>
<p>Offene Bestellungen — Liste der offenen Bestellungen bei Lieferanten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Liste der offenen Bestellungen, welche zum Tagesdatum der Auswertung offen sind. Eingeschränkt werden kann nach Produktmanager, nach bestimmtem Lieferant, nach Zeitraum [Bestelldatum von - Bestelldatum bis], [Lieferdatum von - Lieferdatum bis], nach Artikeln mit nicht bestätigten Lieferdaten. Es ist möglich, den Output nach Lieferantennummer, Bestelldatum oder gewünschtem Lieferdatum zu sortieren.</p>
<p>Pfad: <code v-pre>Logistik → Auswertungen → Offene Bestellungen</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Produkt Manager</dt>
<dd>Produkt Manager, leer = alle</dd>
<dt>Lieferant</dt>
<dd>Lieferant, leer = alle</dd>
<dt>Bestelldatum von</dt>
<dd>inklusive, leer = unbegrenzt</dd>
<dt>Bestelldatum bis</dt>
<dd>inklusive, leer = unbegrenzt</dd>
<dt>Lieferdatum von</dt>
<dd>inklusive, leer = unbegrenzt</dd>
<dt>Lieferdatum bis</dt>
<dd>inklusive, leer = unbegrenzt</dd>
<dt>Sortierung</dt>
<dd>Sortierung nach:- 1= Lieferantennummer - 2= Bestelldatum- 3= Lieferdatum</dd>
<dt>Nur nicht bestätigte</dt>
<dd>nur Artikel, die kein bestätigtes Lieferdatum haben</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Portrait)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Info-Felder</td>
<td>Rekapitulation der eingegebenen Parameter</td>
</tr>
<tr>
<td>Liefer.</td>
<td>Lieferantennummer</td>
</tr>
<tr>
<td>ArtNum</td>
<td>Artikelnummer</td>
</tr>
<tr>
<td>Bezeichnung</td>
<td>Artikelbezeichnung</td>
</tr>
<tr>
<td>Bestellt</td>
<td>Bestelldatum</td>
</tr>
<tr>
<td>LiefDatum</td>
<td>Lieferdatum, welches in der Bestellung gewünscht wurde</td>
</tr>
<tr>
<td>BestMenge</td>
<td>Bestellmenge</td>
</tr>
<tr>
<td>geliefert</td>
<td>Liefermenge bereits geliefert (berücksichtigt bis [Tagesdatum])</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Stamm: Offene Bestellungen                  11.03.1999 10:41:15 leh  Seite     0</span>
<span class="line"></span>
<span class="line"></span>
<span class="line"> Product Manager.....:</span>
<span class="line"> Lieferant...........:          0</span>
<span class="line"> Bestelldatum von....:            bis</span>
<span class="line"> Lieferdatum  von....: 01.10.1998 bis 31.03.1999</span>
<span class="line"> Sortierung..........: 2     nach Bestelldatum</span>
<span class="line"> Nur nicht bestätigte: nein</span>
<span class="line"></span>
<span class="line">   Liefer. ArtNum  Bezeichnung          Bestellt   LiefDatum  BestMenge geliefert</span>
<span class="line">---------- ------- -------------------- ---------- ---------- --------- ---------</span>
<span class="line">   366,877 P0106FR Information Leaflet  18.01.1999 20.02.1999        10         0</span>
<span class="line">   366,877 P0106UK Information Leaflet  18.01.1999 20.02.1999        10         0</span>
<span class="line">   482,130 K995    Kasperli, Handpuppe  02.02.1999 26.02.1999       200       100</span>
<span class="line">   366,877 981B    Childrens just like  12.02.1999 20.02.1999        30         0</span>
<span class="line">.</span>
<span class="line">.</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Lesebeispiel: Vom Artikel &quot;Handpuppe Kasperli&quot; wurden am 2.2.99 200 Stück bestellt. Als gewünschtes Lieferdatum wurde der 26.2.99 an den Lieferanten gemeldet. Zum Auswertungszeitpunkt (Tagesdatum 11.03.1999) sind 100 Stück bereits geliefert worden.</p>
</div></template>


